import React from 'react';
import ReactDOM from 'react-dom';
import "./index.css";
import {SistemRoutes} from "./router";

ReactDOM.render(
  <React.StrictMode>
    <SistemRoutes />
  </React.StrictMode>,
  document.getElementById('root')
);


